import { useEffect, useState } from "react";
import { Download, Share, SquarePlus } from "lucide-react";
import { Panel } from "./common";
import { NotifyPermission } from "./Notifications";
import { Button } from "./ui/button";

let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallApp() {
  const [prompt, setPrompt] = useState(deferred);
  const [installed, setInstalled] = useState(isStandalone());
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); deferred = e; setPrompt(e); };
    const onInstalled = () => { deferred = null; setPrompt(null); setInstalled(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  const install = async () => { prompt.prompt(); const r = await prompt.userChoice; if (r.outcome === "accepted") setInstalled(true); deferred = null; setPrompt(null); };
  return (
    <Panel data-testid="install-app-panel">
      <div className="flex items-start gap-4">
        <img src="/icon-192.png" alt="Icona Porto di Roma Crew" className="w-14 h-14 rounded-2xl shrink-0" />
        <div className="min-w-0 flex-1">
          <h2 className="font-display font-bold text-lg text-[var(--navy)]">App sul telefono</h2>
          {installed ? <p className="text-sm text-slate-600 mt-1" data-testid="install-app-installed">L'app è già sulla schermata Home di questo dispositivo.</p>
            : prompt ? (<><p className="text-sm text-slate-600 mt-1">Aggiungi Porto di Roma Crew alla schermata Home: si apre a schermo intero, come un'app.</p>
              <Button onClick={install} className="rounded-full bg-[var(--teal)] mt-3" data-testid="install-app-button"><Download className="w-4 h-4 mr-1" />Installa l'app</Button></>)
            : isIos() ? <p className="text-sm text-slate-600 mt-1" data-testid="install-app-ios">In Safari tocca <Share className="inline w-4 h-4 mx-0.5 -mt-1" /> <b>Condividi</b>, poi <SquarePlus className="inline w-4 h-4 mx-0.5 -mt-1" /> <b>Aggiungi alla schermata Home</b>.</p>
            : <p className="text-sm text-slate-600 mt-1" data-testid="install-app-manual">Apri il menu del browser (⋮) e scegli <b>Installa app</b> o <b>Aggiungi a schermata Home</b>.</p>}
          <NotifyPermission />
        </div>
      </div>
    </Panel>
  );
}
